<ion-header class="px-3">
  <ion-toolbar>
    <div slot="start" class="flex">
      <dojo-button [fill]="'outline'" (click)="closeModal()">{{ 'cancel' | transloco }}</dojo-button>
    </div>

    <ion-title class="font-primary text-md text-primary text-center font-medium">
      {{ 'select_language' | transloco }}
    </ion-title>

    <div slot="end">
      <dojo-button (click)="save()">{{ 'save' | transloco }}</dojo-button>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="h-full p-4">
    <div class="flex items-center justify-between gap-4">
      @for (language of state.languages; track language.code; let idx = $index) {
        <div class="flex grow justify-center">
          <span
            class="cursor-pointer p-4 hover:bg-neutral-400"
            [class.selected]="language.isSelected"
            (click)="selectLanguage(language.code)"
          >
            {{ language.label }}
          </span>
        </div>
      }
    </div>
  </div>
</ion-content>
